import { setUser } from '@sentry/vue'

export default defineNuxtRouteMiddleware(() => {
  const { user, isAuthenticated } = useAuth()
  const config = useRuntimeConfig()

  if (!isAuthenticated.value) {
    if (process.env.NODE_ENV === 'production') {
      setUser(null)
    }
    return navigateTo(config.public.api.redirects.onAuthOnly, { replace: true })
  }

  if (process.env.NODE_ENV === 'production') {
    setUser({
      id: user.value?.id,
      email: user.value?.email,
    })
  }

  if (user.value?.driver?.is_blocklisted) {
    return navigateTo(config.public.api.redirects.onBlockListed, { replace: true })
  }

  if (user.value?.account_verified_at === null) {
    return navigateTo(config.public.api.redirects.onVerifiedOnly, { replace: true })
  }
})
